export default __webpack_public_path__ + "static/media/p13.abd9cd63.jpg";